import type {
    ILineChartSeries,
} from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/sub-chart/line-chart.interface';
import type { IBaseSubChart } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/sub-chart/base-sub-chart.interface';
import type { IChartLine } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/chart-properties.interface';
import type {
    IUpDownBars,
} from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/sub-chart/sub-chart-properties.interface';

export interface IStockChart extends IBaseSubChart {
    dropLines?: IChartLine;
    highLowLines?: IChartLine;
    upDownBars?: IUpDownBars;
    series: IStockChartSeries[];
}

export enum UpDownBarType {
    DOWN= 'downBars',
    UP = 'upBars',
}

export type IStockChartSeries = ILineChartSeries;
